const Team = [
  {
    id: 1,
    // image : "",
    name: "Therapiya",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam, voluptatum.",
  },
  {
    id: 2,
    // image : "",
    name: "Dentistry",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam, voluptatum.",
  },
  {
    id: 3,
    // image : "",
    name: "Virousology",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam, voluptatum.",
  },
  {
    id: 4,
    // img : "",
    name: "Pharmacology",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam, voluptatum.",
  },
  {
    id: 5,
    // image : "",
    name: "Cardiology",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam, voluptatum.",
  },
  {
    id: 6,
    // image : "",
    name: "Researches",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam, voluptatum.",
  },
];
export default Team;
